var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49774 1.50049H12.502C15.0527 1.50049 16.4927 2.94724 16.5002 5.49799V12.503C16.5002 15.053 15.0527 16.5005 12.502 16.5005H5.49774C2.94699 16.5005 1.50024 15.053 1.50024 12.503V5.49799C1.50024 2.94724 2.94699 1.50049 5.49774 1.50049ZM9.03704 13.3955C9.36029 13.3955 9.62954 13.1555 9.65954 12.833V5.19049C9.68954 4.95799 9.57779 4.72474 9.37529 4.59799C9.16454 4.47049 8.90954 4.47049 8.70779 4.59799C8.50454 4.72474 8.39279 4.95799 8.41454 5.19049V12.833C8.45279 13.1555 8.72204 13.3955 9.03704 13.3955ZM12.4878 13.3955C12.8028 13.3955 13.072 13.1555 13.1103 12.833V10.373C13.132 10.1322 13.0203 9.90799 12.817 9.78049C12.6153 9.65299 12.3603 9.65299 12.1503 9.78049C11.947 9.90799 11.8353 10.1322 11.8653 10.373V12.833C11.8953 13.1555 12.1645 13.3955 12.4878 13.3955ZM6.16452 12.833C6.13452 13.1555 5.86527 13.3955 5.54202 13.3955C5.21952 13.3955 4.94952 13.1555 4.92027 12.833V7.65049C4.89777 7.41724 5.00952 7.18549 5.21277 7.05799C5.41452 6.93049 5.67027 6.93049 5.87277 7.05799C6.07452 7.18549 6.18777 7.41724 6.16452 7.65049V12.833Z",
    fill: "#0A3400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.1bcf3bb4c4ccff0158e4bd7f0a2892e1.svg";
export { ForwardRef as ReactComponent };